import { render, staticRenderFns } from "./questionBank_info_list_set_type_12.vue?vue&type=template&id=2dd24ab9&scoped=true"
import script from "./questionBank_info_list_set_type_12.vue?vue&type=script&lang=js"
export * from "./questionBank_info_list_set_type_12.vue?vue&type=script&lang=js"
import style0 from "./questionBank_info_list_set_type_12.vue?vue&type=style&index=0&id=2dd24ab9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd24ab9",
  null
  
)

export default component.exports